import { graphql } from 'gatsby';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { TextInput } from '@ookla/common-ui';
import Suggestions from './suggestions';
import { filter } from 'lodash';
import constants from './../../utils/constants';
import * as utilFormat from './../../utils/format';
import styles from './typeahead.css';

export default class Typeahead extends Component {
  constructor(props) {
    super(props);
    this.state = { isInputFocused: false };
  }
  static propTypes = {
    search: PropTypes.string,
    // parent page where typeahead is imported
    parent: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        route: PropTypes.string.isRequired
      })
    ),
    onSearchChange: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    search: ''
  };

  getSuggestions = () => {
    const { data, search } = this.props;

    if (!search || search.length < 2) {
      const searchSuggestions = [
        {
          unique: 'suggestions-default',
          suggestions: []
        }
      ];
      if (constants.awardTypes.carrier.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.carrier.label,
            icon: 'mobile',
            route: utilFormat.getAwardTypeRoute('carrier')
          }
        );
      }

      if (constants.awardTypes.isp.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.isp.label,
            icon: 'isp',
            route: utilFormat.getAwardTypeRoute('isp')
          }
        );
      }

      if (constants.awardTypes.coverage.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.coverage.label,
            icon: 'coverage',
            route: utilFormat.getAwardTypeRoute('coverage')
          }
        );
      }

      if (constants.awardTypes.best_mobile.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.best_mobile.label,
            icon: 'bestMobileAward',
            route: utilFormat.getAwardTypeRoute('best_mobile')
          }
        );
      }
      if (constants.awardTypes.best_fixed.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.best_fixed.label,
            icon: 'bestFixed',
            route: utilFormat.getAwardTypeRoute('best_fixed')
          }
        );
      }
      if (constants.awardTypes.best_5g) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.best_5g.label,
            icon: 'best5g',
            route: utilFormat.getAwardTypeRoute('best_5g')
          }
        );
      }
      if (constants.awardTypes['5g'].visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes['5g'].label,
            icon: 'fiveG',
            route: utilFormat.getAwardTypeRoute('5g')
          }
        );
      }

      if (constants.showTopRatedContent && constants.awardTypes.top_rated_carrier.visible) {
        searchSuggestions[0].suggestions.push({
          name: constants.awardTypes.top_rated_carrier.label,
          icon: 'topRatedCell',
          route: utilFormat.getAwardTypeRoute('top_rated_carrier')
        });
      }

      if (constants.showTopRatedContent && constants.awardTypes.top_rated_provider.visible) {
        searchSuggestions[0].suggestions.push({
          name: constants.awardTypes.top_rated_provider.label,
          icon: 'topRatedFixed',
          route: utilFormat.getAwardTypeRoute('top_rated_provider')
        });
      }

      if (constants.awardTypes['5g_video_experience'] && constants.awardTypes['5g_video_experience'].visible) {
        searchSuggestions[0].suggestions.push({
          name: constants.awardTypes['5g_video_experience'].label,
          icon: 'video5gMobile',
          route: utilFormat.getAwardTypeRoute('5g_video_experience')
        });
      }

      if (constants.awardTypes.best_mobile_video_experience && constants.awardTypes.best_mobile_video_experience.visible) {
        searchSuggestions[0].suggestions.push({
          name: constants.awardTypes.best_mobile_video_experience.label,
          icon: 'videoMobile',
          route: utilFormat.getAwardTypeRoute('best_mobile_video_experience')
        });
      }

      if (constants.awardTypes.best_isp_video_experience && constants.awardTypes.best_isp_video_experience.visible) {
        searchSuggestions[0].suggestions.push({
          name: constants.awardTypes.best_isp_video_experience.label,
          icon: 'videoFixed',
          route: utilFormat.getAwardTypeRoute('best_isp_video_experience')
        });
      }

      if (constants.awardTypes.best_5g_gaming_experience.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.best_5g_gaming_experience.label,
            icon: 'best5gGamingExperience',
            route: utilFormat.getAwardTypeRoute('best_5g_gaming_experience')
          }
        );
      }

      if (constants.awardTypes.best_mobile_gaming_experience.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.best_mobile_gaming_experience.label,
            icon: 'bestMobileGamingExperience',
            route: utilFormat.getAwardTypeRoute('best_mobile_gaming_experience')
          }
        );
      }

      if (constants.awardTypes.best_isp_gaming_experience.visible) {
        searchSuggestions[0].suggestions.push(
          {
            name: constants.awardTypes.best_isp_gaming_experience.label,
            icon: 'bestIspGamingExperience',
            route: utilFormat.getAwardTypeRoute('best_isp_gaming_experience')
          }
        );
      }

      return searchSuggestions;
    }

    return [
      {
        unique: 'suggestions-search',
        suggestions: filter(data, datum => {
          return datum.name.toLowerCase().includes(search.toLowerCase());
        })
      }
    ];
  };
  render() {
    const { search, parent, className, onSearchChange } = this.props;
    return (
      <div className={classnames(styles.typeaheadContainer, className)}>
        <div className={styles.inputWrapper}>
          <TextInput
            id="search"
            name="search"
            theme="dark"
            icon="search"
            autoComplete="off"
            iconPosition="prefix"
            label="Search"
            onChange={ev => {
              onSearchChange(ev.target.value);
            }}
            onBlur={() => {
              this.setState({ isInputFocused: false });
            }}
            onFocus={() => {
              this.setState({ isInputFocused: true });
            }}
            placeholder="Enter a location or provider"
            type="text"
            value={search}
            className={styles.typeahead}
            spellCheck={false}
          />
        </div>
        <Suggestions
          className={this.state.isInputFocused ? styles.visible : null}
          parent={parent}
          search={search}
          suggestionLists={this.getSuggestions()}
        />
      </div>
    );
  }
}

export const searchFragment = graphql`
  fragment Search on SitePageConnection {
    edges {
      node {
        context {
          searchString
          searchType
        }
        path
      }
    }
  }
`;
